import { ReactNode } from "react";
import { Params, useParams } from "react-router-dom";
import { LinkOpeningProblemAlert } from "./LinkOpeningProblemAlert";

interface Props {
  nodeExpectingBucketAndItemId: (bucket: string, itemId: string) => ReactNode;
}

export const itemIdParamKey = "itemId";

export function ParamValidatorBucketAndItemId(props: Props) {
  const params: Readonly<Params<string>> = useParams();

  const optionalBucket = params["bucket"];
  const optionalItemId = params[itemIdParamKey];

  function validateAndRender(): ReactNode {
    if (optionalItemId === undefined || optionalBucket === undefined)
      return (
        <LinkOpeningProblemAlert>
          Parameter `bucket`oder `itemId` fehlen.
        </LinkOpeningProblemAlert>
      );

    return props.nodeExpectingBucketAndItemId(optionalBucket, optionalItemId);
  }

  return validateAndRender();
}
